/* Modal */

export enum ModalType {
  DEFAULT = "default",
  DEV_OPTIONS = "dev-options",
  CUSTOM_COHORTS = "custom-cohorts",
}
